import { checkVAT as check, countries } from 'jsvat-next';

export const checkVAT = vatNumber => check(vatNumber, countries).isValid;
